module.exports = __webpack_public_path__ + "static/media/value_prop_img_5.0beb9b26.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-ASURION/value_prop_img_5.jpg
// module id = 1418
// module chunks = 0